import { FormType } from '../../../form-types';

export const womenHairLoss: FormType = {
  name: 'Women Hair Loss',
  questions: [
    {
      key: 'womenHairLoss_sexAssignedAtBirth',
      next: {
        condition: {
          'womenHairLoss_sexAssignedAtBirth.womenHairLoss_sexAssignedAtBirth_female':
            true
        },
        key: 'womenHairLoss_pregnancy',
        els: 'womenHairLoss_ineligible'
      }
    },
    'womenHairLoss_ineligible',
    {
      key: 'womenHairLoss_pregnancy',
      next: {
        condition: {
          'womenHairLoss_pregnancy.womenHairLoss_pregnancy_no': true
        },
        key: 'womenHairLoss_consentPregnancy',
        els: 'womenHairLoss_ineligible'
      }
    },
    {
      key: 'womenHairLoss_consentPregnancy',
      next: {
        condition: {
          'womenHairLoss_consentPregnancy.womenHairLoss_consentPregnancy_agree':
            true
        },
        key: 'womenHairLoss_postMenopausal',
        els: 'womenHairLoss_ineligible'
      }
    },
    'womenHairLoss_postMenopausal',
    {
      key: 'womenHairLoss_affectedAreas',
      next: {
        condition: {
          'womenHairLoss_affectedAreas.womenHairLoss_affectedAreas_other': true
        },
        key: 'womenHairLoss_affectedAreas_other_more',
        els: 'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss'
      }
    },
    'womenHairLoss_affectedAreas_other_more',
    'womenHairLoss_howLongHaveYouBeenExperiencingHairLoss',
    'womenHairLoss_howMuchHairHaveYouLost',
    {
      key: 'womenHairLoss_hairLossCause',
      next: {
        condition: {
          'womenHairLoss_hairLossCause.womenHairLoss_hairLossCause_other': true
        },
        key: 'womenHairLoss_hairLossCause_other_why',
        els: 'womenHairLoss_hairlossPhysician'
      }
    },
    'womenHairLoss_hairLossCause_other_why',
    {
      key: 'womenHairLoss_hairlossPhysician',
      next: {
        condition: {
          'womenHairLoss_hairlossPhysician.womenHairLoss_hairlossPhysician_yes':
            true
        },
        key: 'womenHairLoss_hairLossEvaluation',
        els: 'womenHairLoss_scalpConditions'
      }
    },
    {
      key: 'womenHairLoss_hairLossEvaluation',
      next: {
        condition: {
          'womenHairLoss_hairLossEvaluation.womenHairLoss_hairLossEvaluation_other':
            true
        },
        key: 'womenHairLoss_hairLossEvaluation_other_diagnosis',
        els: 'womenHairLoss_scalpConditions'
      }
    },
    'womenHairLoss_hairLossEvaluation_other_diagnosis',
    'womenHairLoss_scalpConditions',
    'womenHairLoss_scalpIrritation',
    {
      key: 'womenHairLoss_hairLossInDifferentPartsOfBody',
      next: {
        condition: {
          'womenHairLoss_hairLossInDifferentPartsOfBody.womenHairLoss_hairLossInDifferentPartsOfBody_yes':
            true
        },
        key: 'womenHairLoss_hairLossInDifferentPartsOfBody_more',
        els: 'womenHairLoss_hairLossTreatments'
      }
    },
    'womenHairLoss_hairLossInDifferentPartsOfBody_more',
    {
      key: 'womenHairLoss_hairLossTreatments',
      next: {
        condition: {
          'womenHairLoss_hairLossTreatments.womenHairLoss_hairLossTreatments_yes':
            true
        },
        key: 'womenHairLoss_hairLossTreatments_yes_more',
        els: 'womenHairLoss_medicalConditions'
      }
    },
    'womenHairLoss_hairLossTreatments_yes_more',
    'womenHairLoss_medicalConditions',
    {
      key: 'womenHairLoss_moodDisorders',
      next: {
        condition: {
          'womenHairLoss_moodDisorders.womenHairLoss_moodDisorders_yes': true
        },
        key: 'womenHairLoss_moodDisorders_yes_more',
        els: 'womenHairLoss_otherInformationOrQuestions'
      }
    },
    'womenHairLoss_moodDisorders_yes_more',
    'womenHairLoss_otherInformationOrQuestions',
    {
      key: 'womenHairLoss_consent',
      next: {
        condition: {
          'womenHairLoss_consent.womenHairLoss_consent_agree': true
        },
        key: 'womenHairLoss_complete',
        els: 'womenHairLoss_ineligible'
      }
    },
    'womenHairLoss_complete',
    'womenHairLoss_ineligible'
  ]
};
